import { Device, until } from '@helpers/media';
import { clamp } from '@helpers/utils';
import useMedia from '@hooks/useMedia';
import SignpostCard from '@stories/Components/Cards/SignpostCard/SignpostCard';
import TitleAndIntroduction from '@stories/Components/Misc/TitleAndIntroduction/TitleAndIntroduction';
import * as React from 'react';
import S from './Signposts.styles';
const Signposts = (props) => {
    const paddingOffset = useMedia([until(Device.TabletLarge)], [80], 0);
    const rowMax = useMedia([until(Device.MobileLarge), until(Device.TabletLarge), until(Device.DesktopSmall)], [1, 2, 3], 4);
    if (props.cards.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { translations: props.translations, "data-alignment": props.alignment ? props.alignment : 'left', "data-has-carousel": props.hasMobileCarousel ?? false, background: props.bgColour },
        React.createElement(S.Wrapper, null,
            props.title && (React.createElement(TitleAndIntroduction, { title: props.title, introduction: props.introduction, alignment: props.alignment ? props.alignment : 'left' })),
            React.createElement(S.FourColGrid, { mobileCarousel: props.hasMobileCarousel, paddingOffset: paddingOffset, "data-row-max": rowMax, translations: props.translations, carouselType: props.carouselType }, props.cards.map((card, index) => (React.createElement(SignpostCard, { key: index, ...card, translations: props.translations, perRow: clamp(props.cards.length, 4, 2) })))))));
};
export default Signposts;
